import React, { useState, useEffect } from 'react';
import axios from "../../../../axios-order";
import { Snackbar, Alert } from '@mui/material';

function Seventeen({ handleBack, updateTableData, data, reasonsData, title, get_gstr9_report_data }) {
  const [reasonText, setReasonText] = useState('');
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success', // 'success' for green, 'error' for red
  });

  useEffect(() => {
    if (data && Array.isArray(data)) {
      setTotalManualInputs(data.map(item => item.amount_of_itc_total_manual ?? ''));
      setEligibleManualInputs(data.map(item => item.amount_of_itc_eligible_manual ?? ''));
    }
  }, [data]);
  // Initialize inputValues with manual_input from backend data, defaulting to empty string if null/undefined
  // const [inputValues, setInputValues] = useState(data?.map(item => item.manual_input ?? '') || []);

  const [totalManualInputs, setTotalManualInputs] = useState(
    data?.map(item => item.amount_of_itc_total_manual ?? '') || []
  );
  const [eligibleManualInputs, setEligibleManualInputs] = useState(
    data?.map(item => item.amount_of_itc_eligible_manual ?? '') || []
  );

  // Function to convert index to capital letters (A, B, C, ..., Z, AA, AB, etc.)
  const getAlphabeticSerial = (index) => {
    let result = '';
    let num = index;

    do {
      result = String.fromCharCode(65 + (num % 26)) + result;
      num = Math.floor(num / 26) - 1;
    } while (num >= 0);

    return result;
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbar({ ...snackbar, open: false });
  };

  const handleSubmit = async () => {
    const reasons = reasonsData || [{}];
    const payload = {
      business_entity_id: localStorage.getItem("business_entity_id"),
      gstr9c_recon_id: localStorage.getItem("gstr9c_recon_id"),
      records: {
        "17.Late fee payable and paid": data.map((item, index) => ({
          id: item.id,
          gstr9c_recon_id: item.gstr9c_recon_id,
          business_entity_id: item.business_entity_id,
          description: item.description,
          taxable_non_taxable_value: item.taxable_non_taxable_value,
          central_tax: item.central_tax,
          state_tax_ut_tax: item.state_tax_ut_tax,
          integrated_tax: item.integrated_tax,
          cess: item.cess,
          amount_of_itc_total: item.amount_of_itc_total,
          amount_of_itc_eligible: item.amount_of_itc_eligible,

          // Correct mapping
          amount_of_itc_total_manual: totalManualInputs[index] === '' ? null : parseFloat(totalManualInputs[index]),
          amount_of_itc_eligible_manual: eligibleManualInputs[index] === '' ? null : parseFloat(eligibleManualInputs[index]),

          // Remove or keep others if needed
          manual_input: null, // deprecated
          reasons: null
        }))
      }
    };

    try {
      const response = await axios.post("/gstr9c_manual_data_update", payload);
      console.log('Submit response:', response.data);
      // Show snackbar based on response status
      if (response.data.status === true) {
        setSnackbar({
          open: true,
          message: response.data.message || 'Values updated successfully.',
          severity: 'success', // Green snackbar
        });
        if (typeof get_gstr9_report_data === 'function') {
          await get_gstr9_report_data();
        } else {
          console.warn('get_gstr9_report_data is not a function');
        }
      } else {
        setSnackbar({
          open: true,
          message: response.data.message || 'Failed to update values.',
          severity: 'error', // Red snackbar
        });
      }
    } catch (error) {
      console.error('Error submitting data:', error);
      setSnackbar({
        open: true,
        message: 'An error occurred while submitting data.',
        severity: 'error', // Red snackbar for errors
      });
    }
  }

  const handleTotalManualChange = (index, value) => {
    const numericValue = value.replace('₹', '').trim();
    if (numericValue !== '' && !/^-?\d*\.?\d*$/.test(numericValue)) {
      alert('Please enter a valid number.');
      return;
    }
    const newValues = [...totalManualInputs];
    newValues[index] = numericValue;
    setTotalManualInputs(newValues);
  };

  const handleEligibleManualChange = (index, value) => {
    const numericValue = value.replace('₹', '').trim();
    if (numericValue !== '' && !/^-?\d*\.?\d*$/.test(numericValue)) {
      alert('Please enter a valid number.');
      return;
    }
    const newValues = [...eligibleManualInputs];
    newValues[index] = numericValue;
    setEligibleManualInputs(newValues);
  };


  // Handle manual input change for integer values
  // const handleManualInputChange = (index, value) => {
  //   // Remove the rupee symbol before validation
  //   const numericValue = value.replace('₹', '').trim();

  //   // Validate: allow digits, one decimal point, and one negative sign at the start
  //   if (numericValue !== '' && !/^-?\d*\.?\d*$/.test(numericValue)) {
  //     alert('Please enter a valid number (digits, optional negative sign, and optional decimal point).');
  //     return;
  //   }

  //   // Update state with numeric value (without ₹)
  //   const newInputValues = [...inputValues];
  //   newInputValues[index] = numericValue;
  //   setInputValues(newInputValues);

  //   const newData = [...data];
  //   const parsedValue = numericValue === '' ? null : parseFloat(numericValue);
  //   newData[index] = { ...newData[index], manual_input: parsedValue };
  //   console.log(`Updated inputValues[${index}]:`, numericValue, 'New data:', JSON.stringify(newData, null, 2));

  //   if (typeof updateTableData === 'function') {
  //     updateTableData([...newData]); // Ensure new array reference
  //   } else {
  //     console.warn('updateTableData is not a function. Data update skipped.');
  //   }
  // };


  const handleKeyDown = (e, index) => {
    if (index === 15 || index === 17) {
      e.preventDefault();
      console.log(`Keypress blocked for index ${index} (P or R)`);
      return;
    }
    const allowedKeys = [
      '0', '1', '2', '3', '4', '5', '6', '7', '8', '9',
      'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab',
      '-', '.'
    ];
    const input = e.target.value.replace('₹', '').trim();

    // Prevent multiple decimal points
    if (e.key === '.' && input.includes('.')) {
      e.preventDefault();
      return;
    }

    // Prevent multiple negative signs or negative sign not at start
    if (e.key === '-') {
      const cursorPosition = e.target.selectionStart;
      // Allow minus only at position 1 (after ₹) if there's no minus already
      if (input.includes('-') || cursorPosition !== 1) {
        e.preventDefault();
        return;
      }
    }

    // Limit decimal places to 2
    if (e.key >= '0' && e.key <= '9') {
      const parts = input.split('.');
      if (parts.length === 2 && parts[1].length >= 2) {
        // Check if cursor is after the decimal point
        const cursorPosition = e.target.selectionStart;
        const fullValue = e.target.value;
        const decimalPosition = fullValue.indexOf('.');
        // If there's text selected, allow replacement
        if (e.target.selectionStart === e.target.selectionEnd && cursorPosition > decimalPosition) {
          e.preventDefault();
          return;
        }
      }
    }

    if (!allowedKeys.includes(e.key)) {
      e.preventDefault();
    }
  };
  // Log data to verify all records are received
  console.log('Seven component data:', JSON.stringify(data, null, 2));

  return (
    <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif' }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: '20px',
        padding: '30px',
        width: '100%',
        boxShadow: '0 20px 40px rgba(0,0,0,0.1)'
      }}>
        <button
          onClick={handleBack}
          style={{
            marginBottom: '0px',
            padding: '8px 16px',
            backgroundColor: '#f8fafc',
            border: '1px solid #e2e8f0',
            borderRadius: '8px',
            cursor: 'pointer',
            fontSize: '12px',
            color: '#64748b'
          }}
        >
          Back
        </button>

        <h2 style={{
          marginBottom: '20px',
          color: '#1e293b',
          fontSize: '20px',
          fontWeight: '700',
          textAlign: 'center'
        }}>
          {title || 'Table 7 - Reconciliation of Gross Turnover'}
        </h2>

        {/* Table Header */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: '60px 2fr 1fr 1fr', // Four columns
          gap: '10px',
          fontWeight: '600',
          color: '#475569',
          padding: '15px 10px',
          borderBottom: '2px solid #e2e8f0',
          fontSize: '14px',
          backgroundColor: '#f8fafc',
          borderRadius: '8px',
          marginBottom: '10px',
          position: 'sticky',
          top: 0,
          zIndex: 1
        }}>
          <span style={{ textAlign: 'center' }}>S.No.</span>
          <span>Description</span>
          <span style={{ textAlign: 'center' }}>Taxable</span>
          <span style={{ textAlign: 'center' }}>Paid</span>
        </div>

        {/* Table Body */}

        <div style={{
          maxHeight: 'calc(100vh - 450px)', // Adjusted height for banner
          overflowY: 'scroll',
          marginTop: '10px',
          scrollbarWidth: 'thin', // For Firefox
          scrollbarColor: '#64748b #f1f5f9' // For Firefox
        }}>
          <style>
            {`
              div::-webkit-scrollbar {
                width: 12px;
              }
              div::-webkit-scrollbar-track {
                background: #f1f5f9;
                borderRadius: 6px;
              }
              div::-webkit-scrollbar-thumb {
                background: #64748b;
                borderRadius: 6px;
              }
              div::-webkit-scrollbar-thumb:hover {
                background: #475569;
              }
            `}
          </style>
          {data && Array.isArray(data) && data.length > 0 ? (
            data.map((item, index) => {
              // Color palette for S.No. cell, matching Nine
              const getRowColor = (index) => {
                const colors = ['#e0e7ff', '#e9d5ff', '#f3e8ff', '#ede9fe', '#ddd6fe'];
                return colors[index % colors.length];
              };

              return (
                <div key={index} style={{
                  display: 'grid',
                  gridTemplateColumns: '60px 2fr 1fr 1fr', // Match header columns
                  gap: '10px',
                  alignItems: 'center',
                  padding: '10px',
                  borderBottom: '1px solid #f1f5f9',
                  backgroundColor: index % 2 === 0 ? '#ffffff' : '#f8fafc', // Alternating row colors
                  borderRadius: '6px',
                  marginBottom: '2px',
                  minHeight: '40px'
                }}>
                  <span style={{
                    color: '#1e293b',
                    fontSize: '13px',
                    fontWeight: '600',
                    textAlign: 'center',
                    padding: '6px',
                    backgroundColor: getRowColor(index),
                    borderRadius: '6px'
                  }}>
                     {index + 1}
                  </span>
                  <span style={{
                    color: '#334155',
                    fontSize: '13px',
                    padding: '6px 10px',
                    backgroundColor: '#f1f5f9',
                    borderRadius: '6px',
                    wordBreak: 'break-word'
                  }}>
                    {item.description || 'N/A'}
                  </span>
                  <input
                    type="text"
                    value={totalManualInputs[index] !== '' ? `₹${totalManualInputs[index]}` : ''}
                    onChange={(e) => handleTotalManualChange(index, e.target.value)}
                    onKeyDown={(e) => handleKeyDown(e, index)}
                    style={{
                      color: '#1e293b',
                      fontWeight: '500',
                      fontSize: '13px',
                      textAlign: 'right',
                      padding: '6px',
                      border: '1px solid #e2e8f0',
                      backgroundColor: '#ecfdf5',
                      borderRadius: '6px',
                      outline: 'none',
                      width: '100%',
                    }}
                    onFocus={(e) => {
                      e.target.style.borderColor = '#88d8a3';
                      e.target.style.boxShadow = '0 0 0 2px rgba(136, 216, 163, 0.1)';
                      e.target.setSelectionRange(1, e.target.value.length);
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = '#e2e8f0';
                      e.target.style.boxShadow = 'none';
                    }}
                  />
                  <input
                    type="text"
                    value={eligibleManualInputs[index] !== '' ? `₹${eligibleManualInputs[index]}` : ''}
                    onChange={(e) => handleEligibleManualChange(index, e.target.value)}
                    onKeyDown={(e) => handleKeyDown(e, index)}
                    style={{
                      color: '#1e293b',
                      fontWeight: '500',
                      fontSize: '13px',
                      textAlign: 'right',
                      padding: '6px',
                      border: '1px solid #e2e8f0',
                      backgroundColor: '#ecfdf5',
                      borderRadius: '6px',
                      outline: 'none',
                      width: '100%',
                    }}
                    onFocus={(e) => {
                      e.target.style.borderColor = '#88d8a3';
                      e.target.style.boxShadow = '0 0 0 2px rgba(136, 216, 163, 0.1)';
                      e.target.setSelectionRange(1, e.target.value.length);
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = '#e2e8f0';
                      e.target.style.boxShadow = 'none';
                    }}
                  />
                </div>
              );
            })
          ) : (
            <div style={{ textAlign: 'center', color: '#64748b', padding: '20px' }}>
              No data available for this section.
            </div>
          )}
        </div>

        {/* Summary or Footer */}
        {data && Array.isArray(data) && data.length > 0 && (
          <div style={{
            marginTop: '20px',
            padding: '15px',
            backgroundColor: '#f8fafc',
            borderRadius: '8px',
            borderTop: '2px solid #e2e8f0'
          }}>
            <p style={{ margin: '0', fontSize: '14px', color: '#64748b', textAlign: 'center' }}>
              Total Records: {data.length}
            </p>
          </div>
        )}

        {/* Banner with Input and Submit Button */}
        <div style={{
          marginTop: '5px',
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
          height: '80px',
        }}>
          <div>
            <button
              onClick={handleSubmit}
              style={{
                padding: '10px 20px',
                background: 'linear-gradient(135deg, #ffd3a5 0%, #fd9853 50%, #e8a87c 100%)',
                color: 'white',
                border: 'none',
                borderRadius: '6px',
                fontSize: '14px',
                fontWeight: '600',
                cursor: 'pointer',
                boxShadow: '0 4px 12px rgba(255, 211, 165, 0.3)',
                transition: 'all 0.2s ease',
                minWidth: '80px'
              }}
              onMouseOver={(e) => {
                e.target.style.transform = 'translateY(-1px)';
                e.target.style.boxShadow = '0 6px 16px rgba(255, 211, 165, 0.4)';
              }}
              onMouseOut={(e) => {
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = '0 4px 12px rgba(255, 211, 165, 0.3)';
              }}
            >
              Submit
            </button>
          </div>
        </div>

        <Snackbar
          open={snackbar.open}
          autoHideDuration={6000}
          onClose={handleClose}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
          <Alert onClose={handleClose} severity={snackbar.severity} sx={{ width: '100%' }}>
            {snackbar.message}
          </Alert>
        </Snackbar>
      </div>
    </div>
  );
}

export default Seventeen;